import { useNavigate } from 'react-router-dom';
import DocumentAcceptance from './DocumentAcceptance';
import MultiStepForm, { step } from './common/MultiStepForm';
import { useLanguage } from '../utils/LanguageContext';
import './SignupForm.css';
import translations from '../components/ComponentsTranslations.lang.json';
import NameForm from './NameForm';
import PhoneNumberForm from './PhoneNumberForm';
import PayrollAdminTypeForm from './PayrollAdminTypeForm';
import AdminEmployerForm from './AdminEmployerForm';
import { useAuth } from '../utils/AuthContext';
const AdminOnboardingForm = () => {
  const { lang } = useLanguage(translations);
  const { api } = useAuth();
  const navigate = useNavigate();

  const completeOnboardingAndNavigateToDashboard = async () => {
    await api.completeUserAdminOnboarding();
    navigate('/admin/dashboard');
  };

  const steps = [
    step(lang('fullNameTitle'), NameForm),
    step(lang('phoneNumberTitle'), PhoneNumberForm),
    step(lang('payrollAdminTypeTitle'), PayrollAdminTypeForm),
    step(lang('adminEmployerTitle'), AdminEmployerForm),
    step(lang('acceptTermsTitle'), DocumentAcceptance),
  ];

  return <MultiStepForm steps={steps} onCompletion={completeOnboardingAndNavigateToDashboard} />;
};

export default AdminOnboardingForm;
